export const HEADER_CONFIRM_TEXT = 'Save Schedule';
export const HEADER_CUSTOM_PACING_SCHEDULER_TITLE = 'Custom Pacing Scheduler';
export const HEADER_BULK_CUSTOM_PACING_TITLE = 'Bulk Custom Pacing';
export const HEADER_CANCEL_TEXT = 'Cancel';

export const BUILD_CUSTOM_SCHEDULE_TEXT = 'Build a custom schedule';
export const UPLOAD_CSV_TEXT = 'Upload CSV';
export const SET_SCHEDULE_TEXT = 'Set schedule';
export const VIEW_REPORTS = 'View reports';
export const DOWNLOAD_CUSTOM_PACING_TEMPLATE = 'Download Custom Pacing Bulk Edit CSV Template';
export const PAST_CUSTOM_PACING_REPORTS_LABEL = 'View past custom schedule reports:';

export const DEFAULT_HEAVY_UP = 100;
export const CUSTOM_PACING_DATE_FORMAT = 'MM/dd/yyyy HH:mm:ss';

export const DEFAULT_CUSTOM_PACING_TIMEZONE = 'America/New_York';

export const CALCULATE_BUTTON_LABEL = 'Calculate';
export const TIMEZONE_INPUT_LABEL = 'Schedule Timezone';

export const SCHEDULE_START_INPUT_LABEL = 'Schedule Start';
export const SCHEDULE_END_INPUT_LABEL = 'Schedule End';
export const SCHEDULE_HEAVY_UP_INPUT_LABEL = 'Heavy Up';
export const REMOVE_LABEL = 'Remove';

export const INVALID_DATE = 'Invalid date provided';

export const CP_VALIDATION_ERRORS = {
  SCHEDULE_START_IS_REQUIRED: 'Schedule start is required',
  SCHEDULE_END_IS_REQUIRED: 'Schedule end is required',
  HEAVY_UP_IS_REQUIRED: 'Heavy Up is required',
  HEAVY_UP_GREATER_THAN: 'Must be greater than 100',
  SCHEDULE_START_IN_THE_FUTURE: 'Start must be in the future',
  SCHEDULE_END_IN_THE_FUTURE: 'End must be in the future',
  SCHEDULE_START_BEFORE_END: 'End must be after start',
  TIMEZONE_IS_REQUIRED: 'Timezone is required',
  SCHEDULE_CANT_OVERLAP: 'Ranges cannot overlap',
  SCHEDULE_ORDER_ERROR: 'Must be in chronological order',
};

export const FAILURE_TITLE = 'Calculation Failed';
export const UNEXPECTED_ERROR_MESSAGE = 'Unexpected Error';

export const CANNOT_CALCULATE_VALUES_DURING_LOADING_MESSAGE =
  'Cannot calculate a new Custom Pacing, while the previous Custom Pacing is being saved!';

export const NO_LINE_ITEMS_FOUND = 'No eligible line items found';
export const ADJUST_SCHEDULE_NO_LINE_ITEM_FOUND = 'Please adjust Custom Pacing schedule windows';

export const SUMMARY_TABLE_LABELS = {
  NO_SUMMARY_AVAILABLE: 'No summary available',
  PACING_IMPRESSION_TABLE_TITLE: 'Adjusted Window Pacing & Impressions',
  SCHEDULES: 'Schedules',
  PRE_SCHEDULES: 'Pre-Schedules',
  POST_SCHEDULES: 'Post-Schedules',
  N_TH_PACING_SCHEDULE: 'Pacing Schedule',
  PACING: '% Pacing',
  TOTAL_IMPRESSION: 'Total Impressions',
  SUMMARIZE_TABLE_TITLE: 'Summarized Schedule Totals',
  LINES_SCHEDULED: 'Lines Scheduled',
  ESTIMATED_WINDOWS_SHIFT: 'True Estimated Windows Shift',
  DIFFERENCE_OVER_STRAIGHTLINE: 'Difference Over Straightline Daily',
};

export const EMPTY_REPORT_PREVIEW_TABLE_PLACEHOLDER_TEXT =
  'There are no line items eligible for provided custom pacing settings.';

export const CUSTOM_PACING_WAS_SAVED_SUCCESSFULLY_MESSAGE = 'Custom Pacing was saved successfully!';
export const DEFAULT_CUSTOM_PACING_SAVE_ERROR = 'An error occurred during the saving of the custom pacing!';

export const REPORT_LINE_ITEM_LIST_PAGE_SIZE = 20;

export const MAX_HEAVY_UP_VALUE = 2147483647;

export const CUSTOM_PACING_LANDING_STEP_TEXT =
  'Use this tool to apply custom pacing schedules to multiple lines at once in order to maximize relevant ad opportunities. Typically used for targeting live sporting events as a way to pace ad delivery relative to the live inventory availability. You can upload a .csv file or set a schedule in the UI.';

export const CUSTOM_PACING_INFO_TOOLTIPS = {
  START_DATE:
    'Select the date and hour when this pacing schedule begins. Minutes are not editable. Delivery will shift to the Heavy Up percentage starting at this point.',
  END_DATE:
    'Select the date and hour when this pacing schedule ends. Minutes are not editable. After this, delivery returns to normal or moves to the next schedule.',
  HEAVY_UP:
    'The percentage of daily goal to deliver during this schedule window. Enter 200% to double delivery, 150% for 1.5x delivery. Default baseline is 100%.',
  ADD_SCHEDULE:
    'Click to create additional pacing windows. You can set up multiple schedules with different Heavy Up percentages throughout the campaign flight.',
  SCHEDULE_TIMEZONE:
    "The timezone used for all schedule start and end times. Make sure this matches your campaign's target market.",
  CALCULATE:
    'Click to preview how your schedule settings will affect delivery across the campaign flight before saving.',
  PRE_SCHEDULES:
    'The period from campaign start until your first custom schedule begins. Shows pacing % and impressions already delivered or projected before your schedule kicks in.',
  PACING_SCHEDULE:
    "The delivery window you've defined. Shows what percentage of the total campaign goal will be delivered during this schedule and the estimated impression count.",
  POST_SCHEDULES:
    "The remaining flight after all custom schedules end. Must maintain at least 5% pacing to ensure delivery doesn't stop completely.",
  PERCENT_PACING:
    "The percentage of the line's total delivery goal allocated to each window. All windows must add up to 100%.",
  TOTAL_IMPRESSIONS:
    'The estimated number of impressions to be delivered in each window, calculated from % Pacing × Line Item Delivery Goal.',
  LINES_SCHEDULED: 'The number of line items included in this custom pacing schedule.',
  TRUE_ESTIMATED_WINDOW_SHIFT:
    'The total additional impressions being moved into your scheduled windows. Capped at 12 million impressions per line per schedule to prevent over-delivery.',
  DIFFERENCE_OVER_STRAIGHTLINE_DAILY:
    'How many more impressions your schedule will deliver compared to even (straightline) daily pacing. A value of 0 means no change from normal pacing.',
};

export const REPORT_LIST_CONFIRM_TEXT = 'Close';
export const REPORT_LIST_PAGE_TITLE = 'Bulk Pacing Reports';
export const REPORT_LIST_PAGE_LABEL =
  'A report is generated after a custom pacing schedule is created, whether through the UI workflow or by CSV upload.';

export const REPORT_LIST_HEADER_COLUMNS = {
  name: 'Name',
  createDate: 'Create Date',
  userCreated: 'User Created',
  download: 'Download',
};

export const REPORT_LIST_LIMIT = 50;
export const CUSTOM_PACING_REPORT_FILE_TYPE = 'text/csv';
export const DEFAULT_REPORT_LIST_SORT_BY = 'createdAt';

export const CUSTOM_PACING_MAX_AFFECT_LINE_ITEM_LIMIT = 5000;

export const AFFECTED_LINE_ITEMS_LIMIT_REACHED = `The maximum limit of ${CUSTOM_PACING_MAX_AFFECT_LINE_ITEM_LIMIT} line items has been exceeded. Please adjust the Custom Pacing Eligible custom filter criteria and recalculate.`;

export const CUSTOM_ERROR_MESSAGES = Object.freeze<Record<string, string>>({
  O1_SCHEDULE_CLASH:
    'This line item has multiple date ranges that conflict with custom pacing. Remove overlapping schedules before applying.',
  DAY_PART_SCHEDULE_NOT_SUPPORTED:
    'Your daypart exclusions overlap with the custom pacing window. Adjust the schedule dates or remove conflicting dayparts.',
  LINE_ITEM_DOES_NOT_HAVE_SCHEDULE: 'This line item has no schedule to pace. Add a schedule to the line item first.',
  SCHEDULE_END_DATE_EMPTY: 'Custom pacing requires an end date. Set an end date for this line item before applying.',
  LINE_ITEM_SCHEDULE_CLASH:
    "Your custom pacing dates fall outside the line item's flight. Choose dates within the campaign start and end.",
  SOV_LINE_ITEM: "Custom pacing isn't available for Share of Voice line items.",
  OPT_OUT_LINE_ITEM: 'This line item has opted out of custom pacing.',
  LINE_ITEM_SCHEDULE_NOT_VALID:
    "This line item's schedule is missing or invalid. Fix the schedule before applying custom pacing.",
  LINE_ITEM_DOES_NOT_HAVE_DELIVERY_GOAL:
    'Custom pacing requires a delivery goal. Add an impression or delivery goal to this line item.',
  LINE_ITEM_FULLY_DELIVERED: 'This line item has already reached its delivery goal. No pacing adjustments needed.',
  CAN_NOT_CALCULATE_REPORT_METRICS:
    'Something went wrong calculating metrics for this line item. Try again or contact support if the issue persists.',
});

export const SCHEDULE_DATE_INPUT_STEP = 3600;
